import '../Components/_Base';
import '../Components/_Header';
import '../Components/_Footer';
import '../Components/_Anchor';
import '../Components/_Slider';
import '../Components/_MatchHeight';
import '../Components/_Other';
